/**
 * 展示卡片/公告 - 简体中文
 */
export default {
  close: '关闭',
  contactIfObjection: '如有异议，请联系我',
  objectionSubmit: '异议提交',
  objectionContent: '异议内容：',
  placeholderObjectionContent: '请你填写您关于公告的内容',
  objectionContentLength: '请填写您10～100字内的异议内容',
  submitSuccess: '提交成功',
  submitFailed: '提交失败',
  // commodityRatioMsg
  autoOrderRatioTitle: '自动下单商品配比维护',
  agentIdLabel: '代理商ID：',
  ratioTip: '*请务必准确维护各型号配比，自动下单将根据此配比分配下单金额！所有型号配比合计必须等于100%。',
  productModel: '商品型号',
  ratioCol: '配比',
  ratioTotal: '合计',
  ratioTotalWithNum: '（合计{num}%）',
  placeholderRatio: '请输入配比',
  updateLog: '更新记录：',
  ratioRuleError: '请正确填写配比值：1到100的整数，且配比合计等于100%',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  // cardShow 账号升级
  accountUpgrade: '账号升级',
  upgradeIntro: '仅需一分钟，将您的代理商账户升级为',
  squirrelAiAccount: '松鼠Ai账号',
  upgradeBenefits: '升级后获得一下权益：',
  unifiedAccount: '统一账号',
  unifiedAccountDesc: '通过一个手机号码，管理全部的代理商账号、分析员账号',
  securityPrivacy: '安全保密',
  securityDesc: '绑定手机和钉钉提高账号安全性',
  joinTraining: '参与培训',
  trainingDesc: '加入松鼠云上钉钉组织，获得优质培训资料，了解最新功能',
  upgradeNow: '立即升级',
  giveUpRights: '放弃权益',
  bindPhone: '绑定手机号',
  bindPhoneDesc: '我们将根据手机号，创建或绑定松鼠Ai账号',
  phoneLabel: '手机号：',
  placeholderPhoneForRecovery: '请输入账号手机号，可用于找回密码',
  verifyCodeLabel: '验证码：',
  placeholderVerifyCode: '请输入验证码',
  getVerifyCode: '获取验证码',
  resendAfter: 's后重新获取',
  resendVerifyCode: '重新获取验证码',
  continue: '继 续',
  scanToActivate: '扫描完成账号激活',
  goToDingTalk: '前往钉钉完成升级',
  dingTalkStep1: '请使用您上一步提交的手机号登录打开钉钉',
  dingTalkStep2: '系统已向您发送加入总部的团队邀请',
  dingTalkStep3: '同意该邀请后将完成账号的升级',
  refreshHint: '已同意邀请？可试试',
  refresh: '刷新',
  contactSupport: '如遇问题请联系松鼠Ai智能客服',
  accountUpgraded: '账号已经升级',
  mergeAccount: '合并账号',
  mergeAccountDesc: '如果你有其他代理商账号需要合并到松鼠Ai账号，请依次添加',
  accountList: '账号列表',
  addAccount: '+添加账号',
  complete: '完成',
  addAgentAccount: '请添加您的代理商账号',
  accountLabel: '账号：',
  placeholderAccount: '请输入账号',
  passwordLabel: '密码：',
  placeholderPassword: '请输入密码',
  addAccountBtn: '添加账号',
  back: '返回',
  upgradeSuccess: '账号升级成功',
  loginWithNewAccount: '您可以从',
  loginToExperience: '登录，体验升级后的功能。',
  useNewAccountLogin: '使用新账号登录',
  skip: '跳过 >',
  rulePhoneRequired: '请输入账号手机号，可用于找回密码',
  rulePhoneFormat: '请输入正确的手机号',
  ruleVerifyCodeRequired: '请输入验证码',
  ruleVerifyCodeFormat: '验证码格式错误',
  pleaseEnterPhone: '请输入手机号',
  sendSuccess: '发送成功',
  requestFailed: '请求失败',
  addSuccess: '添加成功',
  addFailed: '添加失败',
  refreshed: '已刷新',
  newNoticeTitle: '您有一条新的公告消息',
  viewNoticeDetail: '查看公告详情',
};
